import { createSignal, Show } from "solid-js"
import { HTML_PREVIEW_SANDBOX, htmlPreviewDocument } from "./html-preview-document"

export function SharedHtmlPreview(props: {
  content: string
  filename: string
  previewLabel: string
  sourceLabel: string
}) {
  const [source, setSource] = createSignal(false)
  return (
    <div class="flex flex-col gap-3">
      <div class="flex gap-2">
        <button
          type="button"
          aria-pressed={!source()}
          class="text-12-medium border border-border-weak-base rounded-md px-3 py-1.5 cursor-pointer"
          onClick={() => setSource(false)}
        >
          {props.previewLabel}
        </button>
        <button
          type="button"
          aria-pressed={source()}
          class="text-12-medium border border-border-weak-base rounded-md px-3 py-1.5 cursor-pointer"
          onClick={() => setSource(true)}
        >
          {props.sourceLabel}
        </button>
      </div>
      <Show
        when={!source()}
        fallback={
          <pre class="text-12-mono text-text-base whitespace-pre-wrap break-words overflow-x-auto">{props.content}</pre>
        }
      >
        <iframe
          srcdoc={htmlPreviewDocument(props.content)}
          sandbox={HTML_PREVIEW_SANDBOX}
          referrerpolicy="no-referrer"
          title={props.filename}
          class="w-full h-[70vh] min-h-80 border border-border-weak-base rounded-md bg-white"
        />
      </Show>
    </div>
  )
}
